import './styles.scss';
import CryptoJS from 'crypto-js';

import Lottie from 'react-lottie-player';
import animationData from '../pages/loader.json'; // Local animation file

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faPhone } from '@fortawesome/free-solid-svg-icons';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Alert, Breadcrumbs, Button, Snackbar, Stack, TextField } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

import Rating from '@mui/material/Rating';

import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import CasinoIcon from '@mui/icons-material/Casino';
import ControlCameraIcon from '@mui/icons-material/ControlCamera';
import ForumIcon from '@mui/icons-material/Forum';
import RefreshIcon from '@mui/icons-material/Refresh';

function Home() {
  const [isSticky, setIsSticky] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState({
    visible: false,
    text: '',
  });

  const [isLoading, setIsLoading] = useState(false);
  
  const targetRef = useRef(null);

  const SECKEY = '#Q#b#s#K#b#c#T#H#e#B#e#S#T';

  const toggleDrawer = (open) => () => {
    setOpenDrawer(open);
  };

  const canvasRef = useRef(null);
  const [captchaText, setCaptchaText] = useState('');
  
  // useEffect(() => {
  //   generateCaptcha();
  // }, []);

  const generateCaptcha = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const width = canvas.width;
    const height = canvas.height;

    // Generate random string
    const chars = 'ABCDEFGHJLMNOPRSTUVWXYZabcdefghijkmnopqstuvwxyz0123456789';
    const text = Array.from({ length: 3 }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
    setCaptchaText(text);

    // Clear and background
    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = '#f0f0f0';
    ctx.fillRect(0, 0, width, height);

    // Draw random lines
    for (let i = 0; i < 10; i++) {
      ctx.strokeStyle = `rgba(${Math.random()*200},${Math.random()*200},${Math.random()*200},0.8)`;
      ctx.lineWidth = Math.random() * 2 + 3;
      ctx.beginPath();
      ctx.moveTo(Math.random() * width, Math.random() * height);
      ctx.lineTo(Math.random() * width, Math.random() * height);
      ctx.stroke();
    }

    // Draw noisy dots
    for (let i = 0; i < 50; i++) {
      ctx.fillStyle = `rgba(0,0,0,${Math.random()})`;
      ctx.fillRect(Math.random() * width, Math.random() * height, 1, 1.5);
    }

    // Draw text with distortion
    const charSpacing = width / (text.length + 1);
    ctx.font = 'bold 40px Arial';
    ctx.textBaseline = 'middle';
    ctx.textAlign = 'center';

    for (let i = 0; i < text.length; i++) {
      const char = text[i];
      const x = charSpacing * (i + 1);
      const y = height / 2;
      const angle = (Math.random() - 0.5) * 1.5; // More tilt here (range: -1.5 to 1.5)

      ctx.save();
      ctx.fillStyle = '#333';
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.fillText(char, 0, 0);
      ctx.restore();
    }
  }

  const [formData, setFormData] = useState({})

  const updateForm = (name, value) =>{
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  }
  
  const reserveSeat = async() => {
    const requiredField = ["name", "phone", "email", "health_concern"]
    const missingFields = requiredField.filter(field => {
      const value = formData?.[field];
      return !value || value.trim() === ""; // Check for null, undefined, or empty string
    });

    if (missingFields.length > 0) {
      setSnackbarOpen({
        visible: true,
        text: 'Please fill in missing field and try again.'
      })
      return;
    }

    // if(formData?.captcha !== captchaText){
    //   setSnackbarOpen({
    //     visible: true,
    //     text: 'Invalid Captcha Code. Please try again.'
    //   })
    //   return;
    // }

    // const captchaDataObj = JSON.stringify({
    //   captchaText,
    //   userCaptcha: formData?.captcha
    // });

    // const { iv, encrypted } = encryptData(captchaDataObj, SECKEY);
    setIsLoading(true);

    try {
      const response = await fetch('https://livinghealthyme.com/server/save.php', {//https://livinghealthyme.com/server/save.php ===== http://localhost/health_forum/save.php
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          phone: formData.phone,
          email: formData.email,
          healthConcern: formData.health_concern,
          // e: encrypted,
          // i: iv
        }),
      });
  
      const result = await response.text();
      const jsonOjb = JSON.parse(result)
      if(jsonOjb?.success){
        setSnackbarOpen({
          visible: true,
          text: 'Your seat has been successfully reserved. We will contact you shortly.',
          state: 'success'
        })

        // generateCaptcha();
      }else{
        setSnackbarOpen({
          visible: true,
          text: 'Something went wrong. Please try again.'
        })
      }

      setFormData({});
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error('Error sending request:', error);
    }
    
  }

  // const refreshCaptcha = () => {
  //   generateCaptcha();
  // }

  const encryptData = (data, password) => {
    const iv = CryptoJS.lib.WordArray.random(16); // Generate a random 128-bit IV
    const key = CryptoJS.SHA256(password); // Use SHA256 hash as key (256-bit)
  
    // AES encryption with CBC mode and PKCS7 padding
    const encrypted = CryptoJS.AES.encrypt(data, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
  
    // Return the IV and encrypted ciphertext, both base64 encoded
    return {
      iv: CryptoJS.enc.Base64.stringify(iv),
      encrypted: encrypted.ciphertext.toString(CryptoJS.enc.Base64),
    };
  }

  const handleBottomRsvButton = () => {
    if (targetRef.current) {
      targetRef.current.scrollIntoView({
          behavior: 'smooth', // Smooth scrolling
          block: 'start', // Scroll to the start of the element
      });
    }
  }

  const Loader = () => {
      // Styles for the overlay and loader container
      const styles = {
          overlay: {
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(0, 0, 0, 0.1)', // light translucent background
              backdropFilter: 'blur(1px)', // adds the blur effect
              zIndex: 9999,
          },
          loaderContainer: {
              position: 'relative',
              width: 300,
              height: 300,
          },
      };

      return (
          <div style={styles.overlay}>
              <div style={styles.loaderContainer}>
                  <Lottie
                      loop
                      animationData={animationData} // JSON animation data
                      play // autoplay
                      style={{ width: 300, height: 300 }}
                  />
              </div>
          </div>
      );
  };

  return (
    <div className="Home">
      {
        isLoading &&
        <Loader />
      }
      <Snackbar open={snackbarOpen?.visible} autoHideDuration={5000} onClose={() => setSnackbarOpen({
        visible: false,
        text: '',
        state: snackbarOpen?.state ?? 'error'
      })} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert
          onClose={() => setSnackbarOpen({
            visible: false,
            text: '',
            state: snackbarOpen?.state ?? 'error'
          })}
          severity={snackbarOpen?.state ?? 'error' }
          variant="filled"
          sx={{ width: '100%' }}
        >
          { snackbarOpen?.text }
        </Alert>
      </Snackbar>

      <div className="main_wrapper">
        <Stack className="navheader">
          
          <Stack className={`header_menu_container ${isSticky ? 'sticky' : ''}`}>
            <Stack className='header_menu'>
              <Stack className='left_side'>
                  <span className='featured'>QBS KBC Health Forum</span>
              </Stack>
            </Stack>
          </Stack>
        </Stack>

        <Stack className='header_bg_wrapper'>
          <Stack className='header_image_container'>
            <Stack className='header_section'>
              <img alt='header' src="/images/header_bg.jpg" className='header_image' />
            
              <Stack className='header_main_text'>
                  <Stack className="left">
                    {/* <h4 className='h4_container'>[ LEAD GENERATION SERVICE ]</h4> */}
                    <h1 className='h1_container'>Heart Attack. Stroke. Diabetes. Learn to Fight Back Before They Strike​</h1>
                    <h3 className='h3_container'>Stop Disease Before It Starts: Join the Health Risk Prevention Forum.​</h3>
                 
                    {/* <div className='get_started_btn_container'>
                      <Button className='get_started_btn' variant="contained" endIcon={<ChevronRightIcon />}>
                        Get Started Now
                      </Button>
                    </div> */}
                 </Stack>
                <Stack className="right" ref={targetRef}>
                      {/* <Stack className='stars_container'>
                        <Rating
                          name="simple-uncontrolled"
                          defaultValue={5}
                          readOnly
                          size='large'
                        />
                      </Stack> */}

                      <Stack className='right_header_container'>
                          <h1>Join us and take charge of your health. Your heart and future depend on it!</h1>
                      </Stack>
                      
                      <Stack className='quote_text_container'>
                          Secure your slot today
                      </Stack>
                      
                      <Stack className='form_container'>
                        <TextField
                          id="outlined-basic"
                          label="Name"
                          name="name"
                          variant="outlined"
                          className='form_inputs'
                          value={formData.name || ''} // <-- make it controlled
                          sx={{
                            backgroundColor: 'white',
                            '& .MuiInputLabel-root': {
                              color: 'gray', // <-- Placeholder/Label color
                            },
                            '& .MuiInputLabel-root.Mui-focused': {
                              color: '#4c9eff', // <-- Color when focused
                            },
                          }}
                          onChange={(e) => updateForm(e.target.name, e.target.value)}
                        />

                        <TextField
                          id="outlined-basic"
                          label="Phone"
                          name="phone"
                          variant="outlined"
                          className='form_inputs'
                          value={formData.phone || ''} // <-- make it controlled
                          sx={{
                            backgroundColor: 'white',
                            '& .MuiInputLabel-root': {
                              color: 'gray', // <-- Placeholder/Label color
                            },
                            '& .MuiInputLabel-root.Mui-focused': {
                              color: '#4c9eff', // <-- Color when focused
                            },
                          }}
                          onChange={(e) => updateForm(e.target.name, e.target.value)}
                        />

                        <TextField
                          id="outlined-basic"
                          label="Email"
                          name="email"
                          variant="outlined"
                          className='form_inputs'
                          value={formData.email || ''} // <-- make it controlled
                          sx={{
                            backgroundColor: 'white',
                            '& .MuiInputLabel-root': {
                              color: 'gray', // <-- Placeholder/Label color
                            },
                            '& .MuiInputLabel-root.Mui-focused': {
                              color: '#4c9eff', // <-- Color when focused
                            },
                          }}
                          onChange={(e) => updateForm(e.target.name, e.target.value)}
                        />

                        <TextField
                          className='form_inputs'
                          variant="outlined"
                          name="health_concern"
                          placeholder='Do you have health concern?'
                          value={formData.health_concern || ''} // <-- make it controlled
                          multiline
                          rows={4}
                          sx={{
                            backgroundColor: 'white',
                            '& .MuiInputLabel-root': {
                              color: 'gray', // <-- Placeholder/Label color
                            },
                            '& .MuiInputLabel-root.Mui-focused': {
                              color: '#4c9eff', // <-- Color when focused
                            },
                            resize: 'none'
                          }}
                          onChange={(e) => updateForm(e.target.name, e.target.value)}
                        />

                        {/* <Stack className='captcha_container' style={{ marginTop: '20px', alignItems: 'center', flexDirection: 'row', gap: '20px' }}>
                          <TextField
                            id="outlined-basic"
                            name="captcha"
                            label="Captcha"
                            variant="outlined"
                            className='captchaInput'
                            sx={{
                              backgroundColor: 'white',
                              '& .MuiInputLabel-root': {
                                color: 'gray', // <-- Placeholder/Label color
                              },
                              '& .MuiInputLabel-root.Mui-focused': {
                                color: '#4c9eff', // <-- Color when focused
                              },
                              borderRadius: '4px'
                            }}
                            onChange={(e) => updateForm(e.target.name, e.target.value)}
                          />
                          <canvas ref={canvasRef} style={{ borderRadius: '4px', width: '48%', textAlign: 'center' }} height={88} />
                          
                          <Stack sx={{ cursor: 'pointer' }}
                            onClick={() => {
                              refreshCaptcha()
                            }}
                          >
                            <RefreshIcon sx={{ color: '#fff' }} />
                          </Stack>
                        </Stack> */}

                        <Stack style={{ marginTop: '20px' }}>
                          <Button 
                          onClick={() => {
                            reserveSeat()
                          }}
                          style={{ padding: '14px', fontWeight: '700', fontSize: '20px', textTransform: 'capitalize' }} variant="contained" >
                            Reserve My Seat
                          </Button>
                        </Stack>

                      </Stack>

                  </Stack>
              </Stack>
            
              <Stack className='event_details'>
                <h1>Join our "Health and Wellness Forum" </h1>
                <h2>[&nbsp; May 10, 2025 Saturday 2:00PM  | Zillion Pavillion, Lipa City Batangas &nbsp;]</h2>
              </Stack>

            </Stack>
          </Stack>
        </Stack>

        <Stack className='video_container'>
          <video controls poster="/images/video_thumbnail.png">
            <source src="/videos/diabetes_video.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </Stack>

        <Stack className='first_content_container'>
          <Stack className='first_content_wrapper'>
            <Stack className='content_column'>

                <Stack sx={{ marginBottom: '20px' }}>
                  <img alt='header' src="/images/signs_header_image.png" className='diabetes_signs_image' />
                </Stack>
                <Stack className='content_description'>
                  <h4>The Shocking Truth About Diabetes and Heart Disease</h4>
                  <Stack className='diabetes_truth_container'>
                    <img alt='header' src="/images/3x_diabetes.png" className='diabetes_image' />
                    <span>
                      If you have diabetes, your risk of developing heart disease is nearly doubled. You might think, “It won’t happen to me,” but statistics tell a different story. Adults with diabetes are almost twice as likely to suffer from heart attacks or strokes compared to those without this condition.
                      Imagine waking up one day feeling fine, only to find out that you’ve been living on borrowed time. Heart disease can strike when you least expect it — will you be prepared?
                    </span>
                  </Stack>
                </Stack>
            </Stack>
            <Stack className='content_column'>
              <Stack className='content_description'>
                <h3>Are You Ignoring the Warning Signs?</h3>

                <Stack className='signs_row_container'>
                  <Stack className='signs_row' sx={{ borderLeft: '3px solid #1c6eee' }}>
                      <Stack className='signs_title'>
                          <h2>Do you smoke?</h2>
                      </Stack>
                      <Stack className='signs_description'>
                        Smoking can double your risk of heart disease. If you’re still lighting up, it’s time to quit!
                      </Stack>
                  </Stack>
                  
                  <Stack className='signs_row' sx={{ borderLeft: '3px solid #049754' }}>
                      <Stack className='signs_title'>
                          <h2>Is your blood pressure high?</h2>
                      </Stack>
                      <Stack className='signs_description'>
                        High blood pressure makes your heart work overtime. This silent killer could be lurking inside you, waiting for the right moment to strike.
                      </Stack>
                  </Stack>
                  
                  <Stack className='signs_row' sx={{ borderLeft: '3px solid #8e9704' }}>
                      <Stack className='signs_title'>
                          <h2>What about your cholesterol?</h2>
                      </Stack>
                      <Stack className='signs_description'>
                        High levels of LDL (bad cholesterol) can lead to blockages in your arteries, increasing your risk of heart attacks and strokes.
                      </Stack>
                  </Stack>
                  
                  <Stack className='signs_row' sx={{ borderLeft: '3px solid #5d0497' }}>
                      <Stack className='signs_title'>
                          <h2>Are you overweight?</h2>
                      </Stack>
                      <Stack className='signs_description'>
                        Obesity can make it harder to manage your diabetes and significantly raise your risk of heart disease.
                      </Stack>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </Stack>

        <Stack className='second_content_container article_container'>
          <Stack className='article_header_container'>
            <h1>Protect Your Heart</h1>
            <h2>Don’t let diabetes lead you to a heart attack or stroke</h2>
            <h4>
              Every Day Counts! Did you know that diabetes can silently destroy your heart? Every day, countless individuals unknowingly face the terrifying reality that high blood glucose levels can damage their blood vessels and nerves. This damage paves the way for heart disease, heart attacks, and strokes—three of the deadliest health threats of our time.
            </h4>
          </Stack>

          <Stack className='article_content_container'>
              <Stack className='article_content_row'>
                <Stack className='article_content_column'>
                  <Stack className='action_icon_container'>
                    <Stack className='icon_container'>
                        <DirectionsRunIcon className='icon' sx={{ color: '#a060fd' }} />
                    </Stack>
                    <Stack className='action_title_container'>
                      Take Action Now
                    </Stack>
                  </Stack>
                  
                  <Stack className='action_body_container'>
                    Don’t wait until it’s too late. The good news is that you have the power to change your destiny. By making conscious choices about your health today, you can protect yourself from heart attacks and strokes.
                  </Stack>
                </Stack>
                <Stack className='article_content_column'>
                  <Stack className='action_icon_container'>
                    <Stack className='icon_container'>
                        <CasinoIcon className='icon' sx={{ color: '#164ca3' }} />
                    </Stack>
                    <Stack className='action_title_container'>
                      Don't Gamble With Your Health
                    </Stack>
                  </Stack>
                  
                  <Stack className='action_body_container'>
                    The consequences of ignoring your health can be dire. Heart attacks and strokes are not just statistics; they are life-altering events that can leave you and your loved ones devastated.
                  </Stack>
                </Stack>
              </Stack>

              <Stack className='row_seperator'></Stack>

              <Stack className='article_content_row'>
                <Stack className='article_content_column'>
                  <Stack className='action_icon_container'>
                    <Stack className='icon_container'>
                        <ControlCameraIcon className='icon' sx={{ color: '#998400' }} />
                    </Stack>
                    <Stack className='action_title_container'>
                      Take Control of Your Health Today
                    </Stack>
                  </Stack>
                  
                  <Stack className='action_body_container'>
                    Don’t wait for the warning signs to appear. Make a change and protect your heart, learn more how to prevent these health risk. 
                    Your life is worth it!
                  </Stack>
                </Stack>
                <Stack className='article_content_column'>
                  <Stack className='action_icon_container'>
                    <Stack className='icon_container'>
                        <ForumIcon className='icon' sx={{ color: '#0c863e' }} />
                    </Stack>
                    <Stack className='action_title_container'>
                    Join Us for a Life-Changing Health Forum
                    </Stack>
                  </Stack>
                  
                  <Stack className='action_body_container'>
                    Don’t leave your health to chance—take proactive steps to safeguard your future! We invite you to attend our upcoming Health Forum, where you will learn invaluable strategies for managing diabetes, preventing heart attacks, and reducing your risk of stroke.
                  </Stack>
                </Stack>
              </Stack>

              <Stack className='row_seperator'></Stack>
          </Stack>
        </Stack>

        <Stack className='third_content_container'>
          <Stack className='third_content_wrapper'>
            <Stack className='third_content_header'>
              <Stack className='header_column'>
                  <h1>What You’ll Gain by Attending</h1>

                  <span>
                    Join us and take charge of your health. Your heart and future depend on it!
                    <span className='text_seperator'><br /></span>
                    <font className='sub_text'>Register Now to secure your spot at the Health Forum and start your journey toward a healthier, more vibrant life!</font>
                  </span>
              </Stack>
            </Stack>
            <Stack className='third_content_body'>
              <Stack className='body_column'>
                  <Stack className='body_image_container'>
                    <img alt='insights' src="/images/insights.jpg" className='insights_image' />
                  </Stack>
                  <Stack className='body_descrpition_container'>
                     <Stack className='title'>
                        Expert Insights
                     </Stack>
                     <Stack className='description'>
                     Hear from leading health professionals who specialize in diabetes and cardiovascular health.
                     </Stack>
                  </Stack>
              </Stack>
              <Stack className='body_column'>
                  <Stack className='body_image_container'>
                    <img alt='practical_tips' src="/images/practical_tips.jpg" className='practical_tips_image' />
                  </Stack>
                  <Stack className='body_descrpition_container'>
                    <Stack className='title'>
                        Practical Tips
                    </Stack>
                    <Stack className='description'>
                    Discover simple lifestyle changes that can have a profound impact on your well-being.
                    </Stack>
                  </Stack>
              </Stack>
              <Stack className='body_column'>
                  <Stack className='body_image_container'>
                    <img alt='networking' src="/images/networking.jpg" className='networking_image' />
                  </Stack>
                  <Stack className='body_descrpition_container'>
                    <Stack className='title'>
                        Networking Opportunities
                    </Stack>
                    <Stack className='description'>
                    Connect with others who share your concerns and goals, and build a supportive community.
                    </Stack>
                  </Stack>
              </Stack>
            </Stack>
            
            <Stack className='reserve_btn_container'>
                <h1>Don’t wait until it’s too late!</h1>

                <div style={{ marginTop: '20px' }}>
                  <Button
                  onClick={() => {
                    handleBottomRsvButton();
                  }}
                  style={{ padding: '14px 50px 14px 50px', fontWeight: '700', fontSize: '20px', textTransform: 'capitalize' }} variant="contained" >
                    Reserve My Seat
                  </Button>
                </div>
              </Stack>
          </Stack>
        </Stack>

        <Stack className='footer_content_container'>
          <Stack className='footer_content_wrapper'>
              <Stack className='footer_column'>
                  <h4>Queen Boss Society | King Boss Club | All Rights Reserved. 2025</h4>
              </Stack>
          </Stack>
        </Stack>
      </div>
    </div>
  );
}

export default Home;
